import React from "react";

const Event = (props) => {
  const { event, setIsFormOpen } = props;
  return (
    <div className="virtual-events-event" id={event.name.replace(/\s/g, "")}>
      <div className="container">
        <div className="virtual-events-event__copy">
          <h3>{event.name}</h3>
          <p className="virtual-events-event__description">{event.copy}</p>
          <button
            className="button button--dark"
            onClick={() => setIsFormOpen(true)}
            data-ga={`virtual_events_${event.name}--enquire-now`}
          >
            Enquire Now
          </button>
        </div>
        <img
          className="virtual-events-event__image"
          src={event.img}
          alt="Event image"
        />
      </div>
    </div>
  );
};

export default Event;
